import React from "react";
import "./Login.css";
import Footer from "../Footer/Footer";
import NavBar from "../NavBar/NavBar";
import { Link } from "react-router-dom";
import { SERVER_ADDRESS } from "../../../constants";

class Login extends React.Component {
    constructor(props) {
        super(props);

        this.verifyInput = this.verifyInput.bind(this);
        this.login = this.login.bind(this);
        this.checkLogin = this.checkLogin.bind(this);
        this.checkEnter = this.checkEnter.bind(this);
    }

    async login(username, password) {
        let data = JSON.stringify({ username, password });
        try {
            let result = await fetch(`${SERVER_ADDRESS}/users/login`, {
                method: "POST",
                body: data,
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json"
                }
            })
            if(result) {
                result = await result.json();
            }
            this.props.setUser({
                username: result.username,
                email: result.email,
                name: result.name,
                approved: result.approved,
                paid: result.paid
            });
        } catch(error) {
            console.log(error);
        }
    }

    verifyInput(username, password) {
        if (username.length >= 3 && password.length >= 8) {
            this.login(username, password);
        } else {
            console.log("need valid input")
        }
    }

    checkLogin(event) {
        const username = document.getElementById("login-username").value;
        const password = document.getElementById("login-password").value;
        event.preventDefault();
        this.verifyInput(username, password);
    }

    checkEnter(event) {
        if(event.key === "Enter") {
            const username = document.getElementById("login-username").value;
            const password = document.getElementById("login-password").value;
            this.verifyInput(username, password)
        }
    }

    render() {
        return (
            <div onKeyPress={this.checkEnter}>
                <NavBar/>
                <div id="login-container">
                    <h3>Login</h3>
                    <form id="login">
                        <input id="login-username" placeholder="Username"></input>
                        <input id="login-password" type="password" placeholder="Password"></input>
                    </form>
                    <p onClick={this.checkLogin} id="login-button">Go</p>
                    <p>Need an account? <Link to="/register">Register</Link></p>
                </div>
                <Footer/>
            </div>
        );
    }
}

export default Login;